import i18n from "@/i18n";
import { TemplateTypeEnum } from "@/services/templates/types";

export const templatesFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    // {
    //     key: "type",
    //     label: i18n.t("common.type"),
    //     formatter: formatType
    // },
    {
        key: "actions",
        label: ""
    },
    {
        key: "drag",
        label: "",
        class: "draggable-btn-cell"
    }
];

// function formatType(type: TemplateTypeEnum) {
//     return i18n.t(`solution.${TemplateTypeEnum[type]}`);
// }
